import { Center } from "@chakra-ui/react";
import portret from "../../../assets/images/logo-type.png";

const AppFallback = () => {
  return (
    <Center height="100%" width="100%">
      <img 
        style={{ opacity: 0.2, width: '50px' }} 
        src={portret} 
        alt="app-fallback" 
      />
    </Center>
  );
};

export default AppFallback;
